import {
  prop,
  length,
  compose,
  difference,
  keys,
  defaultTo,
  pluck,
} from 'ramda';

import { search as algoliaSearch } from '../api/algolia';
import { handleError } from '../actions/errors';
import { getSearchPager } from '../selectors/search';
import { getDocumentsByIds } from './prismic';

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const SEARCH_INIT_PAGER = 'SEARCH_INIT_PAGER';
export const SEARCH_HOLD_PAGER = 'SEARCH_HOLD_PAGER';

export const searchRequest = (lang, key, page) => ({
  type: SEARCH_REQUEST,
  lang,
  key,
  page,
});

export const searchSuccess = (lang, key, page, data = {}) => ({
  type: SEARCH_SUCCESS,
  payload: data,
  lang,
  key,
  page,
});

export const searchFailure = (lang, key, page, error) => ({
  type: SEARCH_FAILURE,
  payload: error,
  lang,
  key,
  page,
});

export const searchInitPager = (lang, key, config) => ({
  type: SEARCH_INIT_PAGER,
  payload: config,
  lang,
  key,
});

export const searchHold = (lang, key) => ({
  type: SEARCH_HOLD_PAGER,
  lang,
  key,
});

const loaded = compose(keys, defaultTo({}), prop('loaded'));
const extractIds = compose(pluck('id'), defaultTo([]), prop('results'));

export const search = (mapper) => (
  key,
  pageNumber,
  config,
  reset = true
) => async (dispatch, getState) => {
  const { locale } = getState();
  const filters = config?.query;
  const query = mapper(filters);
  const page = pageNumber || 1;

  if (reset) {
    dispatch(
      searchInitPager(locale, key, {
        ...config,
        query,
        filters,
        lang: locale,
      })
    );
  }

  try {
    const pager = getSearchPager(key, getState());

    dispatch(searchRequest(locale, key, page));

    const results = await algoliaSearch({
      ...pager.options.query,
      lang: pager.options.lang,
      page,
    });

    const ids = difference(extractIds(results), loaded(getState()));
    if (length(ids) > 0) {
      const getDocuments = getDocumentsByIds(ids);
      await getDocuments(dispatch, getState);
    }

    dispatch(searchSuccess(locale, key, page, results));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);

    const fallback = searchFailure(locale, key, page, error);
    handleError(dispatch, error, fallback);
  }
};
